import { useFetch } from '../../../../biz/hooks/data/useFetcher';

export const useGeoCode = () => {
    const f = useFetch();
    return {
        geoCode: async (address: string): Promise<IGeoCodeResponse> => {
            const url = "/api/map/geocode?address=" + encodeURIComponent(address);
            return await f.get(url)
        },
        getGeoAutoComplete: async (address: string): Promise<IAutoCompleteResponse> => {
            const url = "/api/map/geocode/autocomplete?address=" + encodeURIComponent(address);
            return await f.get(url)
        }
    }
}

export interface IGeoCodeResponse {
    results: Result[]
    status: string
}

export interface Result {
    address_components: AddressComponent[]
    formatted_address: string
    geometry: Geometry
    navigation_points?: NavigationPoint[]
    place_id: string
    types: string[]
}

export interface AddressComponent {
    long_name: string
    short_name: string
    types: string[]
}

export interface Geometry {
    bounds?: Bounds
    location: Location
    location_type: string
    viewport: Viewport
}

export interface Bounds {
    northeast: Northeast
    southwest: Southwest
}

export interface Northeast {
    lat: number
    lng: number
}

export interface Southwest {
    lat: number
    lng: number
}

export interface Location {
    lat: number
    lng: number
}

export interface Viewport {
    northeast: Northeast2
    southwest: Southwest2
}

export interface Northeast2 {
    lat: number
    lng: number
}

export interface Southwest2 {
    lat: number
    lng: number
}

export interface NavigationPoint {
    location: Location2
}

export interface Location2 {
    latitude: number
    longitude: number
}


// AutoComplete

export interface IAutoCompleteResponse {
    predictions: Prediction[]
    status: string
}

export interface Prediction {
    description: string
    matched_substrings: MatchedSubstring[]
    place_id: string
    reference: string
    structured_formatting: StructuredFormatting
    terms: Term[]
    types: string[]
}

export interface MatchedSubstring {
    length: number
    offset: number
}

export interface StructuredFormatting {
    main_text: string
    main_text_matched_substrings: MainTextMatchedSubstring[]
    secondary_text: string
}

export interface MainTextMatchedSubstring {
    length: number
    offset: number
}

export interface Term {
    offset: number
    value: string
}
